import React, { useEffect, useState } from "react";
import { Card, Form, Select, Skeleton, Transfer, Typography } from "antd";
import type { TransferDirection } from "antd/es/transfer";
import { useParams } from "react-router";
import { LuckyManagementService } from "../services/lucky-management.service";
import { useId24 } from "../../../drivers/id24/Id24Provider";
import { useForm } from "antd/lib/form/Form";
import Meta from "antd/es/card/Meta";
import { loadAppConfig } from "../../../configs/app-config";
import { TransferKey } from "antd/es/transfer/interface";

interface RecordType {
  key: string;
  title: string;
  description: string;
}
export type TuserCheckin = {
  listUsers: {
    id: number;
    nameTh: string;
    nameEn: string;
    nickname: string;
    company: {
      id: number;
      companyName: string;
    };
  };
};
type TUserList = {
  id: number;
  userId: string;
  numberId: string;
  fullName: string;
  email: string;
  company: string;
  department: string | null;
  position: string;
  phone: string;
  qrcodeId: string | null;
  confirmStatus: false;
  registerStatus: false;
  seatno: string | null;
  registerDate: string;
  agendaId: string;
  createDate: string;
  updateDate: string;
};
export type useroflucky = {
  id: number;
  luckyId: number;
  listUsersId: number;
  luckyWinnerId: number;
  listUsers: {
    id: number;
    nameTh: string;
    nameEn: string;
    nickname: string;
    createdAt: string | Date;
    updatedAt: string | Date;
    companyId: number;
  };
  lucky: {
    id: number;
    nameLucky: string;
  };
};

const sizeStyle = {
  width: "500px",
  height: "500px",
};

export const LuckyManagementUser: React.FC = (): React.ReactElement => {
  const { id24Axios } = useId24();
  const apiBaseUrl = id24Axios(loadAppConfig().REACT_APP_API_BASE_URL);
  const { id, agendaid } = useParams<{ id: string; agendaid: string }>();
  const [form] = useForm();
  const [targetKeys, setTargetKeys] = useState<TransferKey[]>([]);
  // const [selectedKeys, setSelectedKeys] = useState<string[]>([]);
  const [usersList, setUserList] = useState<RecordType[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (loading && agendaid) loadData();
  }, [loading]);

  const loadData = async () => {
    if (agendaid) {
      const useroflucky = await LuckyManagementService(
        apiBaseUrl
      ).findluckofusersById(id);
      const userslist = await LuckyManagementService(
        apiBaseUrl
      ).findUsersOptionByAgenda(agendaid, undefined);
      console.log(userslist);
      const userOptions = userslist.map((item: TUserList) => {
        return {
          key: item.id,
          title: item.fullName,
          description: "",
        };
      });
      console.log(userOptions);
      setUserList(
        userslist.map((item: TUserList) => {
          return {
            key: item.id,
            title: item.fullName,
            description: "",
          };
        })
      );

      setTargetKeys(
        userslist
          .filter((itemA: TUserList) =>
            useroflucky.some(
              (itemB: useroflucky) => itemA.id === itemB.listUsersId
            )
          )
          .map((item: TUserList) => {
            return item.id;
          })
      );
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const onValuesChange = async (event: { status: boolean }) => {
    if (agendaid) {
      const userslist = await LuckyManagementService(
        apiBaseUrl
      ).findUsersOptionByAgenda(agendaid, event.status);
      setUserList(
        userslist.map((item: TUserList) => {
          return {
            key: item.id,
            title: item.fullName,
            description: "",
          };
        })
      );
    }
  };

  const onChange = async (
    nextTargetKeys: TransferKey[],
    direction: TransferDirection,
    moveKeys: TransferKey[]
  ) => {
    LuckyManagementService(apiBaseUrl).setUsertoLucky(id, nextTargetKeys);
    setTargetKeys(nextTargetKeys);
  };

  // const onSelectChange = (
  //   sourceSelectedKeys: string[],
  //   targetSelectedKeys: string[]
  // ) => {
  //   setSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys]);
  // };

  // const onScroll = (
  //   direction: TransferDirection,
  //   e: React.SyntheticEvent<HTMLUListElement>
  // ) => {};

  return loading ? (
    <Card className="w-full">
      <Skeleton loading={loading} avatar active>
        <Meta
          avatar={<img src="https://joeschmoe.io/api/v1/random" alt="avatar" />}
          title="Card Title"
          description="Card description"
        />
      </Skeleton>
    </Card>
  ) : (
    <Card className="w-full">
      <Typography className="text-[20px] font-bold">{`รายชื่อผู้มีสิทธิ์เข้าร่วม`}</Typography>
      <br></br>
      <Form form={form} onValuesChange={onValuesChange}>
        <Form.Item name={"status"} label="status filter">
          <Select
            className="w-1/2"
            options={[
              { value: true, label: "CheckIn" },
              { value: false, label: "No CheckIn" },
            ]}
          />
        </Form.Item>
      </Form>
      <div className="flex justify-center items-center h-[70vh]">
        <Transfer
          listStyle={sizeStyle}
          dataSource={usersList}
          titles={["รายชื่อทั้งหมด", "รายชื่อผู้มีสิทธิ์เข้าร่วม"]}
          targetKeys={targetKeys}
          // selectedKeys={selectedKeys}
          onChange={onChange}
          // onSelectChange={onSelectChange}
          // onScroll={onScroll}
          render={(item) => item.title}
        />
      </div>
    </Card>
  );
};
